"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankAccountVerificationResult = void 0;
// The outcome of verifying a customer's external bank account (via GIACT + our own checks). Shared across the
// cash-out and payments flows and consumed by both aven_backend and the aven_my frontend, so it lives in aven_types
// rather than being hand-copied per surface.
var BankAccountVerificationResult;
(function (BankAccountVerificationResult) {
    // Default fallback: we couldn't auto-verify, route the customer to upload a bank statement.
    BankAccountVerificationResult["UPLOAD_DOCUMENTS"] = "UPLOAD_DOCUMENTS";
    BankAccountVerificationResult["PASS"] = "PASS";
    BankAccountVerificationResult["CANNOT_BE_VERIFIED"] = "CANNOT_BE_VERIFIED";
    BankAccountVerificationResult["ROUTING_NUMBER_INVALID"] = "ROUTING_NUMBER_INVALID";
})(BankAccountVerificationResult || (exports.BankAccountVerificationResult = BankAccountVerificationResult = {}));
